/*
 * @Author: wsx
 * @Date: 2021-04-02 23:20:10
 * @LastEditTime: 2021-07-29 15:52:37
 * @LastEditors: Please set LastEditors
 * @Description: 创建上下文（使用依赖注入实现，可用于组件间的传值）
 * @FilePath: \hz-finances\src\hooks\core\useContext.ts
 */
/* eslint-disable symbol-description */
import {
  provide,
  inject,
  reactive,
  readonly as defineReadonly,
  defineComponent
} from 'vue';

export function createContext(key, context, options = {}) {
  const { readonly = true, createProvider = false, native = false } = options;

  const state = reactive(context);
  const provideData = readonly ? defineReadonly(state) : state;
  !createProvider && provide(key, native ? context : provideData);

  const Provider = createProvider
    ? defineComponent({
      name: 'Provider',
      inheritAttrs: false,
      setup(_, { slots }) {
        provide(key, provideData);
        return () => slots.default?.();
      }
    })
    : null;

  return {
    Provider,
    state
  };
}

export function useContext(key, defaultValue) {
  return inject(key, defaultValue || {});
}
